<template>
  <div class="admin-header">
    <div class="header-left">
      <img src="@/assets/weather-icon_128.png" alt="logo">
      <h1>Weather Admin</h1>
    </div>
    <div class="header-right" @click="goToHome">
      <i class="el-icon-s-home"></i>
      <p>主页</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminHeader',
  methods: {
    goToHome() {
      this.$router.push('/');
    }
  }
}
</script>

<style lang="less">
  .admin-header {
    display: flex;
    justify-content: space-between;
    padding: 10px 0 0;
    .header-left {
      display: flex;
      img {
        width: 30px;
        flex: none;
      }
      h1 {
        color: #555;
        font-size: 20px;
        padding-left: 10px;
      }
    }
    .header-right {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #999;
      cursor: pointer;
      &:hover {
        color: #666;
      }
      .el-icon-s-home {
        margin-right: 5px;
      }
    }
  }
</style>